import { render, staticRenderFns } from "./UserAddForm.vue?vue&type=template&id=0c15032b&scoped=true&"
import script from "./UserAddForm.vue?vue&type=script&lang=ts&"
export * from "./UserAddForm.vue?vue&type=script&lang=ts&"
import style0 from "./UserAddForm.vue?vue&type=style&index=0&id=0c15032b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c15032b",
  null
  
)

export default component.exports